function init() {
  window.initHeaderType = headerType => {
    const { body } = document;
    body.dataset.headerType = headerType;

    const headerSection = document.querySelector(`.header-section-${headerType}`);
    const templateSliderForHeaderOne = document.querySelector('.template-slider-for-header-one');

    if (headerSection) {
      headerSection.classList.remove('hidden');
    }

    if (templateSliderForHeaderOne) {
      if (headerType !== 1) {
        templateSliderForHeaderOne.classList.add('hidden');
      } else {
        templateSliderForHeaderOne.querySelectorAll('img[data-src]').forEach(img => {
          img.setAttribute('src', img.dataset.src);
        });
      }
    }

    const event = new Event('curtain');
    window.dispatchEvent(event);
  };

  window.addEventListener('load', () => {
    window.initHeaderType(4);
    window.handleVariantView('v4');
  });
}

(() => {
  init();
})();
